export default "__VITE_ASSET__3b842d8b__"